module.exports = __webpack_public_path__ + "img/img.f09cc6f4.png";